(function () {
  function prepareVideo(video) {
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      video.removeAttribute('autoplay');
      video.pause();
      return;
    }

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
  }

  function init() {
    var videos = document.querySelectorAll('[data-amour-workshop-video]');
    for (var index = 0; index < videos.length; index += 1) prepareVideo(videos[index]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
